import * as API from "services/api"
import { ORG_SIGN_IN_PATH } from "utils/routeHelpers"
import { BroadcastChannel } from "broadcast-channel"
import { errorToast } from "shared/toast"
import { expireActivityHubCookies } from "./locationSaverHelpers"

const END_SESSION = "end_session"

const logoutChannel = new BroadcastChannel(END_SESSION)

export const endSession = async () => {
  logoutChannel.postMessage(END_SESSION)

  expireActivityHubCookies()

  const response = await API.signOut()

  if (response.ok) {
    if (response.data === undefined || response.data.length === 0) {
      window.location = ORG_SIGN_IN_PATH
    } else {
      const [firstsignOutUrl, ...additionalUrls] = response.data

      additionalUrls.forEach((url) => window.open(url, "_blank"))
      window.location = firstsignOutUrl
    }
  } else {
    errorToast("Something went wrong. Unable to sign out.")
  }
}

export const endAllTabSessionsListener = () => {
  logoutChannel.onmessage = () => {
    endSession()
    logoutChannel.close()
  }
}
